module.exports = __webpack_public_path__ + "static/media/christmass.c02b2b7c.png";